import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { getCoupon } from "../../services/coupon.service";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";

export default function CouponDetails() {
  const { token } = useSelector((state) => state?.auth);
  const [coupon, setCoupon] = useState(null);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const couponId = params.get("id");

  const fetchCoupon = async () => {
    try {
      const res = await getCoupon(token, couponId);

      if (res && res.status >= 200 && res.status < 300) {
        // console.log(res.data);

        setCoupon(res?.data);
      } else {
        Swal.fire(
          "Error",
          "Failed to fetch coupon details. Please try again.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error fetching coupon details:", error);
      Swal.fire(
        "Error",
        "An error occurred while fetching the coupon. Please try again later.",
        "error"
      );
    }
  };

  useEffect(() => {
    if (couponId) {
      fetchCoupon();
    }
  }, [couponId]);

  return (
    <div className="content-body">
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12 col-lg-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Coupon Details</h4>
                <Link to="/coupons">
                  <img src="/assets/images/kidskart/icon/back-button.png" />
                </Link>
              </div>
              <div className="card-body">
                <div className="row">
                  {/* Coupon code */}
                  <div className="col-sm-6 mb-4">
                    <h5>Coupon Code</h5>
                    <p>{coupon?.coupon_code || "N/A"}</p>
                  </div>

                  {/* type */}
                  <div className="col-sm-6 mb-4">
                    <h5>Coupon Type</h5>
                    <p>{coupon?.coupon_type || "N/A"}</p>
                  </div>

                  {/* Off Percentage */}
                  <div className="col-sm-6 mb-4">
                    <h5>Offer {coupon?.coupon_type}</h5>
                    <p>
                      {coupon?.coupon_type === "Amount"
                        ? "₹" + coupon?.coupon_amount
                        : coupon?.coupon_percent + "%" || "N/A"}
                    </p>
                  </div>

                  {/* Min Ammount */}
                  <div className="col-sm-6 mb-4">
                    <h5>Min. Ammount</h5>
                    <p>₹{coupon?.min_applicable_amount || "N/A"}</p>
                  </div>

                  {/* Max Allowed Coupon */}
                  <div className="col-sm-6 mb-4">
                    <h5>Max. Allowed Coupon</h5>
                    <p>{coupon?.max_allowed_coupon || "N/A"}</p>
                  </div>

                  {/* Status */}
                  <div className="col-sm-6 mb-4">
                    <h5>Status</h5>
                    <p>{coupon?.status ? "ACTIVE" : "EXPIRED" || "N/A"}</p>
                  </div>

                  {/* Expiry Date */}
                  <div className="col-sm-6 mb-4">
                    <h5>Expiry Date</h5>
                    <p>{coupon?.expiry_date || "N/A"}</p>
                  </div>

                  {/* Offer */}
                  <div className="col-md-12 mb-4">
                    <h5>Offer Text</h5>
                    <p>{coupon?.offer_text || "No Offer text Provided"}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
